import { render, staticRenderFns } from "./DsfExamPractice.vue?vue&type=template&id=632e7efc&"
import script from "./DsfExamPractice.vue?vue&type=script&lang=js&"
export * from "./DsfExamPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfExamPractice.vue"
export default component.exports